export default "__VITE_ASSET__But6$mMj__"